import { Component, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { GbTheme, THEME_SIGNAL } from '../../../interfaces/theme';

export enum ToastTypes {
  Error = 'error',
  Success = 'success',
}

@Component({
  selector: 'app-toaster',
  imports: [TranslatePipe],
  templateUrl: './toaster.component.html',
  styleUrl: './toaster.component.scss',
})
export class ToasterComponent {
  public message = input.required<string>();

  public toastType = input.required<ToastTypes>();

  public ToastTypes = ToastTypes;

  public showDismiss = input(true);

  public specialContent = input<string | null>(null);

  public theme = inject(THEME_SIGNAL);

  public readonly GbTheme = GbTheme;
}
